import defaultsDeep from 'lodash/defaultsDeep';
import has from 'lodash/has';
import Structure from './Structure';

export default function Question(values = {}) {
  return defaultsDeep(
    {
      ...values,
      structure: has(values, 'structure') ? Structure(values.structure) : Structure(),
    },
    {
      type: 'MCQ',
      structure: Structure(values?.structure),
      index: -1,
      _id: '',
      startedAt: '',
      time: 30000,
      v: 0,
      clones: [],
      cloned: false,
      published: false,
      deleted: false,
      isSuperParent: false,
      metaData: {},
      topics: [],
      standards: [],
      marksUpdated: false,
    },
  );
}
